import { render, staticRenderFns } from "./ConfigTabMapa.vue?vue&type=template&id=945721ac&scoped=true"
import script from "./ConfigTabMapa.vue?vue&type=script&lang=js"
export * from "./ConfigTabMapa.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabMapa.vue?vue&type=style&index=0&id=945721ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945721ac",
  null
  
)

export default component.exports